var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("normalDialog", {
    attrs: {
      title: _vm.$t("label_essweb_Tax_form_editTitle"),
      dialog: _vm.show,
      maxWidth: "600",
      width: "600",
    },
    on: {
      close: function ($event) {
        return _vm.$emit("close")
      },
    },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function () {
          return [
            _c(
              "v-form",
              { ref: "form", attrs: { "lazy-validation": "" } },
              [
                _c(
                  "v-row",
                  { attrs: { align: "center" } },
                  [
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c("normalInputTextFiled", {
                          attrs: {
                            isRequire: "",
                            rules: _vm.$GetRules(["_Require_Rules"], [null]),
                            label: _vm.$t(
                              "label_essweb_Tax_list_fileNameLabel"
                            ),
                          },
                          model: {
                            value: _vm.fileInfo.doc_title,
                            callback: function ($$v) {
                              _vm.$set(_vm.fileInfo, "doc_title", $$v)
                            },
                            expression: "fileInfo.doc_title",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c("DateTimePicker", {
                          attrs: {
                            type: "date",
                            label: _vm.$t("label_essweb_List_dialog_DateLabel"),
                            defaultTime: _vm.fileInfo.release_utc_datetime,
                            placeholder: "YYYY/MM/DD",
                          },
                          on: {
                            change: function (time) {
                              _vm.fileInfo.release_utc_datetime = time
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "actions",
        fn: function () {
          return [
            _c("CardActions", {
              attrs: { submitBtn: "" },
              on: {
                submit: _vm.toSubmit,
                cancel: function ($event) {
                  return _vm.$emit("close")
                },
              },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }